module.exports = __webpack_public_path__ + "img/Karpicko_White_Logo_2021.0f2dcef4.png";